import { queryClient } from "@shared/api/query-client";
import { reachGoal } from "@utils/lib/yandexMetrika";
import { clearStoredActiveProfile, getStoredActiveProfile, storeActiveProfile } from "@utils/lib/activeProfile";
import { createContext, useCallback, useContext, useMemo, useState } from "react";

const ActiveProfileContext = createContext(null);

export const ActiveProfileProvider = ({ children }) => {
	const [storedProfile, setStoredProfile] = useState(getStoredActiveProfile);

	// Переключение активного профиля: сохраняем профиль и сбрасываем кеш серверного состояния,
	// так как расписание/занятия зависят от активного профиля.
	// null — возврат в контекст владельца аккаунта (без заголовка X-Active-Profile-Id).
	const setActiveProfile = useCallback((profile) => {
		setStoredProfile(profile ?? null);
		storeActiveProfile(profile);
		queryClient.invalidateQueries();
		reachGoal('switch-active-profile', {
			profile_id: profile?.id ?? null,
			is_child: Boolean(profile?.is_child),
		});
	}, []);

	// Сброс без инвалидации кеша: используется при выходе из аккаунта,
	// когда вся сессия завершается и кеш чистится целиком.
	const clearActiveProfile = useCallback(() => {
		setStoredProfile(null);
		clearStoredActiveProfile();
	}, []);

	const value = useMemo(() => ({
		activeProfile: storedProfile,
		setActiveProfile,
		clearActiveProfile,
	}), [storedProfile, setActiveProfile, clearActiveProfile]);

	return (
		<ActiveProfileContext.Provider value={value}>
			{children}
		</ActiveProfileContext.Provider>
	);
};

// null — провайдер не подключён; не должно происходить при корректной сборке провайдеров
export const useActiveProfile = () => useContext(ActiveProfileContext);
